import ImageWithBasePath from "@/components/image-with-base-path"

const SupportSection = () => {
  return (
    <>
  {/* Start Support Section */}
  <div className="section support-section-fifteen">
    <div className="container">
      <div
        className="support-content-fifteen wow fadeInUp"
        data-wow-duration="2s"
      >
        Support for Your <br /> Better Healing
        <p className="item-one item">Mental Health</p>
        <p className="item-two item">Therapy &amp; Counseling</p>
        <p className="item-three item">Medical / Wellness</p>
        <p className="item-four item">Rehabilitation</p>
      </div>
    </div>
    <ImageWithBasePath
      src="assets/img/bg/round-element-1.svg"
      alt=""
      className="img-fluid element-one"
    />
    <ImageWithBasePath
      src="assets/img/bg/round-element-2.svg"
      alt=""
      className="img-fluid element-two"
    />
  </div>
  {/* End Support Section */}
</>

  )
}

export default SupportSection